module.exports = __webpack_public_path__ + "media/up-down.07c44eba.mp4";